import React from 'react';
import {Editor} from "@tinymce/tinymce-react";

const Index = ({editorRef, value}) => {
    return (
        <>
            <Editor
                apiKey="9xcb4e438t885wdognpfrn2f5518zqu1ayv4vk40aw2jae5g"
                onInit={(evt, editor) => editorRef.current = editor}
                initialValue={value ? value : ""}
                init={{
                  height: 500,
                  menubar: true,
                  branding: false,
                  plugins: [
                    'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                    'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                    'insertdatetime', 'media', 'table', 'code', 'image', 'imagetools', 'media'
                  ],
                  toolbar: 'undo redo | blocks | ' +
                      'bold italic forecolor | alignleft aligncenter ' +
                      'alignright alignjustify | bullist numlist outdent indent | ' +
                      'removeformat | image media',
                  content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
                  readonly: false,
                  toolbar_sticky: true,
                }}
            />
        </>
    );
};

export default Index;
